<template>

  <div class="row">
    <div class="col-md-12 mt-5">

      <Tab v-if="getApps.length > 0">

        <Tabs name="Contratados" :quantity="installed.length">
          <h5 class="mb-4"><strong>Apps contratados</strong></h5>

          <div class="media media-style mb-2 pb-2 pt-2" v-for="app in installed" :key="app.id">
            <div class="ml-3 mr-3 my-auto icon-card">
              <component v-if="app.icon" :is="app.icon" />
              <XIcon v-else />
            </div>
            <div class="media-body">
              <strong>{{ app.nickname }}</strong>
              <p class="truncate text-muted"><span v-html="app.description"></span></p>

            </div>
            <div style="align-self: center;padding-left: 10px;padding-right: 30px;">
              <router-link :to="buildPath(app)">
                <button class="btn btn-primary">
                  Acessar aplicativo
                </button>
              </router-link>
            </div>
          </div>

        </Tabs>

        <Tabs name="Marketplace">
          <h5 class="mb-4"><strong>Loja de aplicativos</strong></h5>

          <div class="media media-style mb-2 pb-2 pt-2" v-for="app in apps" :key="app.id">
            <div class="ml-3 mr-3 my-auto icon-card">
              <component v-if="app.icon" :is="app.icon" />
              <XIcon v-else />
            </div>
            <div class="media-body">
              <strong>{{ app.nickname }}</strong>
              <p class="truncate text-muted"><span v-html="app.description"></span></p>

            </div>
            <div style="align-self: center;padding-left: 10px;padding-right: 30px;">
              <router-link :to="`/apps/${app.name}`">
                <button class="btn btn-primary">
                  Mais informações
                </button>
              </router-link>
            </div>
          </div>

        </Tabs>

      </Tab>

    </div>
  </div>

</template>

<script>
import { SearchIcon, BookIcon, EditIcon, FileTextIcon, InfoIcon, MailIcon, XIcon } from 'vue-feather-icons';
import TabContainer from '@/components/shares/TabContainer'
import Tabs from '@/components/shares/Tab'
import GetAccountApps from '@/mixins/GetAccountApps'
import GetAccount from '@/mixins/GetAccount.vue'
import GetPartner from '@/mixins/GetPartner'
import { getAppDisplayName } from '@/appDisplayNames'

export default {
  components: { BookIcon, EditIcon, FileTextIcon, InfoIcon, MailIcon, SearchIcon, Tab: TabContainer, Tabs, XIcon },
  computed: {
    apps() {
      return this.getApps
        .filter(app => app.appType === 'app')
        .map(app => ({
          ...app,
          nickname: this.displayName(app.name)
        }))
    },
    installed() {
      return this.getAccountApps
        .filter(accountApp => accountApp.active)
        .map(accountApp => this.getApps.find(link => link.name === accountApp.name))
        .filter(Boolean)
        .map(app => ({ ...app, nickname: this.displayName(app.name) }))
    }
  },
  methods: {
    buildPath(app) {
      if (app.name === 'driver-indication')
        return '/indicacao-condutores'

      if (['message', 'cm-crono', 'cm-embarcador'].includes(app.name))
        return app.name

      return this.$parse.pluralize(app.name)
    },
    displayName(appName) {
      return getAppDisplayName(appName, this.getPartner)
    },
  },
  mixins: [GetAccountApps, GetAccount, GetPartner],
  name: 'Index'
}
</script>

<style scoped>
.truncate {
  overflow: hidden;
  max-height: 8rem;
  -webkit-box-orient: vertical;
  display: block;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
}

.media-style {
  border: 1px solid #E1E3EB;
  border-radius: 5px;
}
</style>
